import Model from './Model';
import * as moment from 'moment';
import User from "./User";
import ArrayList from './ArrayList';
import Category from './Category';
import Designer from './Designer';
import Status from './Status';
import ProcessType from './ProcessType';
import Condition from './Condition';
import Media from './Media';
import Currency from './Currency';
import Address from './Address';
class Product extends Model {
  constructor(options) {
    super();
    (this as any).user = d => {
			return new User(d.data);
		};
    (this as any).categories = d => {
      return new ArrayList<Category>(Category, d.data);
    };
    (this as any).designer = d => {
      return new Designer(d.data);
    };
    (this as any).process_status = d => {
      return new Status(d.data);
    };
    (this as any).process_type = d => {
      return new ProcessType(d.data);
    };
    (this as any).condition = d => {
      return new Condition(d.data);
    };
    (this as any).media = d => {
      return new ArrayList<Media>(Media, d.data);
    };
    (this as any).currency = d => {
      return new Currency(d.data);
    };
    (this as any).calculated_payout_currency = d => {
      return new Currency(d.data);
    };
    (this as any).fix_payout_currency = d => {
      return new Currency(d.data);
    };
    this.bind(options);
  }
}

class Order extends Model {
	user: (d: any) => void;
  order_id: String;
	constructor(options) {
		super();

		(this as any).user = d => {
			return new User(d.data);
		};

		(this as any).shipping_address = d => {
			return new Address(d.data);
		};

		(this as any).billing_address = d => {
			return new Address(d.data);
		};
		this.bind(options);
	}
}
class OrderProduct extends Model {
  created_at: any;
  is_return_allowed: any;
  product_price: any;
  quantity: any;
  cancelled_at: any = null;
  returnable: any;
  cancelled_by_id: any = null;
  return_status_id: any = null;
  delivery_status_id: any = null;
  constructor(options) {
    super();
    (this as any).cancelled_by = d => {
      return new User(d.data);
    };
    (this as any).order = d => {
      return new Order(d.data);
    };
    (this as any).product = d => {
      return new Product(d.data);
    };
    (this as any).courier = d => {
      return d.data;
    };
    this.bind(options);
  }
  getCancelledAtMoment(): moment.Moment {
    if (this['cancelled_at'] === null) {
      return null;
    }
    let m = moment(this['cancelled_at']);
    return m;
  }

  assertLastOrderProductNotShipped() {
    return (this as any).shipment_status && (this as any).shipment_status === 'READY_TO_SHIP' && (this as any).tracking_status_url;
  }
}

export default OrderProduct;
